<pv-view
    *ngIf="reportState$ | async as state"
    [toolbarTitle]="state?.report?.label || 'Untitled Document'"
    [showToolbar]="!preview"
    [showMenu]="!preview"
    [editableTitle]="true"
    (onTitleChange)="updateReportTitle($event)">

    <!-- TOOLBAR -->
    <div pv-view-tools class="report-actions" *ngIf="!preview">
        <!-- Report Filter -->
        <button mat-icon-button
                matTooltip="Report Filter"
                (click)="openFilterDialog()">
            <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
        </button>

        <!-- Preview Report -->
        <button mat-icon-button
                matTooltip="Print"
                (click)="print()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
        </button>

        <!-- Refresh Report -->
        <button mat-icon-button
                matTooltip="Refresh"
                (click)="reload()">
            <mat-icon class="material-symbols-outlined">sync</mat-icon>
        </button>

        <!-- Share Report -->
        <button mat-icon-button
                matTooltip="Share Report"
                (click)="shareReport(state.key, state.ownerOrgKey)">
            <mat-icon class="material-symbols-outlined">share</mat-icon>
        </button>


        <mat-divider class="section-divider" vertical></mat-divider>

        <!-- Extract Template -->
        <button mat-icon-button
                matTooltip="Extract Template"
                (click)="extractTemplate()">
            <mat-icon class="material-symbols-outlined">assignment_add</mat-icon>
        </button>

        <!-- Apply Template -->
        <button [class.active]="rightActive == 'TEMPLATES'"
                mat-icon-button
                matTooltip="Apply Template"
                (click)="toggleTemplates()">
            <mat-icon class="material-symbols-outlined">assignment</mat-icon>
        </button>
    </div>
    <!-- TOOLBAR -->

    <mat-drawer-container hasBackdrop="false" pv-view-body>

        <!-- LEFT SIDEBAR -->
        <mat-drawer #leftDrawer pv-view-sidebar class="no-print" [ngClass]="{'left-sidebar': !leftHemisphere, 'sidebar-opened': leftHemisphere}" *ngIf="!preview">
            <div class="sidebar-heading">
                <span *ngIf="leftHemisphere; else altHeading">Available Elements</span>
                <ng-template #altHeading>
                    <mat-icon class="report-logo" svgIcon="culteva:icon"></mat-icon>
                </ng-template>
            </div>

            <mat-divider></mat-divider>

            <!-- FULL SIDEBAR -->
            <ng-container *ngIf="leftHemisphere; else collapsedSidebar">
                <div class="sidebar-list">
                    <div matRipple class="sidebar-list-item clickable-item" (click)="addImageItem(state)">
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                        <span>Add Image Item</span>
                    </div>
                    <div matRipple class="sidebar-list-item clickable-item" (click)="addTextItem(state)">
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                        <span>Add Text Item</span>
                    </div>
                    <div matRipple class="sidebar-list-item clickable-item" (click)="addChartItem(state)">
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                        <span>Add Chart Item</span>
                    </div>
                    <div matRipple class="sidebar-list-item clickable-item" (click)="addIndexItem(state)">
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                        <span>Add Index Item</span>
                    </div>
                    <div matRipple class="sidebar-list-item clickable-item" (click)="addTableItem(state)">
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                        <span>Add Table Item</span>
                    </div>
                    <div matRipple class="sidebar-list-item clickable-item" (click)="addGanttItem(state)">
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                        <span>Add Gantt Chart</span>
                    </div>
                    <div matRipple class="sidebar-list-item clickable-item" (click)="addPage()">
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                        <span>Add Page</span>
                    </div>
                    <div matRipple
                        class="sidebar-list-item"
                        [class.active-item]="editMode"
                        [class.clickable-item]="!editMode"
                        [class.edit-flash]="editFlash"
                        (click)="toggleEditMode(!editMode)"
                    >
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        <span>Edit</span>
                    </div>
                </div>
            </ng-container>

            <!-- COLLAPSED SIDEBAR -->
            <ng-template #collapsedSidebar>
                <div class="sidebar-buttons">
                    <button mat-icon-button
                            matTooltip="Add Image"
                            (click)="addImageItem(state)">
                        <mat-icon class="material-symbols-outlined">image</mat-icon>
                    </button>
                    <button mat-icon-button
                            matTooltip="Add Text"
                            (click)="addTextItem(state)">
                        <mat-icon class="material-symbols-outlined">text_fields</mat-icon>
                    </button>
                    <button mat-icon-button
                            matTooltip="Add Chart"
                            (click)="addChartItem(state)">
                        <mat-icon class="material-symbols-outlined">bar_chart</mat-icon>
                    </button>
                    <button mat-icon-button
                            matTooltip="Add Index"
                            (click)="addIndexItem(state)">
                        <mat-icon class="material-symbols-outlined">graph_5</mat-icon>
                    </button>
                    <button mat-icon-button
                            matTooltip="Add Table"
                            (click)="addTableItem(state)">
                        <mat-icon class="material-symbols-outlined">table_view</mat-icon>
                    </button>
                    <button mat-icon-button
                            matTooltip="Add Gantt Chart"
                            (click)="addGanttItem(state)">
                        <mat-icon class="material-symbols-outlined">timeline</mat-icon>
                    </button>
                    <button mat-icon-button
                            matTooltip="Add Page"
                            (click)="addPage(state)">
                        <mat-icon class="material-symbols-outlined">note_add</mat-icon>
                    </button>
                    <button [class.active]="editMode"
                            [class.edit-flash]="editFlash"
                            mat-icon-button
                            matTooltip="Edit Mode"
                            (click)="toggleEditMode(!editMode)">
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                    </button>
                </div>
            </ng-template>

            <div class="sidebar-toggle-button"
                [ngClass]="{'left-toggle-passive': !leftHemisphere, 'left-toggle-active': leftHemisphere}"
                (click)="leftDrawer.toggle()">

                <mat-icon>{{ leftHemisphere ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}</mat-icon>
            </div>
        </mat-drawer>
        <!-- LEFT SIDEBAR -->

        <mat-drawer-content class="report-body" [class.no-print]="preview">

            <ng-container [ngSwitch]="state.status">

                <!-- Phase 1: fetching the report → Culteva logo loader. Once status is OK the pages render
                     and each component shows its own skeleton (in its grid slot) until its data arrives. -->
                <pv-view-loader *ngSwitchCase="'LOADING'" message="Loading Report..."></pv-view-loader>

                <ng-container *ngSwitchCase="'OK'">
                    <ng-container *ngIf="state as report">
                        <ng-container *ngFor="let key of report.pageKeys; index as i">
                            <pv-report-page
                                [key]="key"
                                [reportKey]="report.key"
                                [shareKey]="shareKey"
                                [index]="(i+1)"
                                [total]="report.pageKeys.length"
                                [editMode]="editMode">
                            </pv-report-page>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <pv-view-message *ngSwitchDefault
                    [heading]="state.status | descStatusTitle"
                    [message]="state.status | descStatusMessage:'Generated Report'"
                    icon="error"
                >
                    <button mat-button
                        color="primary"
                        pvMessageAction
                        (click)="reload(false)"
                    >
                        Reload
                    </button>
                </pv-view-message>
            </ng-container>

        </mat-drawer-content>

        <!-- RIGHT SIDEBAR -->
        <mat-drawer #rightDrawer position="end" class="no-print" pv-view-sidebar-right [ngClass]="{'sidebar': !rightHemisphere, 'sidebar-opened': rightHemisphere}" *ngIf="!preview">
            <div class="sidebar-toggle-button"
                [ngClass]="{'right-toggle-passive': !rightHemisphere, 'right-toggle-active': rightHemisphere}"
                (click)="rightDrawer.toggle()">

                <mat-icon>{{ rightHemisphere ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</mat-icon>
            </div>

            <!-- HIDE DRAWER CONTENT -->
            <ng-container *ngIf="showRightContent">

                <!-- RIGHT DRAWER STATUS -->
                <ng-container [ngSwitch]="state.rightDrawerStatus">

                    <!-- STATUS: LOADING -->
                    <ng-container *ngSwitchCase="'LOADING'">
                        <pv-spinner fill="white"></pv-spinner>
                    </ng-container>

                    <!-- STATUS: OK -->
                    <ng-container *ngSwitchCase="'OK'">
                        <!-- SWITCH DRAWER CONTEXT -->
                        <ng-container [ngSwitch]="rightActive">
                            <ng-container *ngSwitchCase="'TEMPLATES'">
                                <div class="template-panel">
                                    <div class="template-panel-heading">
                                        <mat-icon class="material-symbols-outlined">dashboard_customize</mat-icon>
                                        <span>Apply Template</span>
                                    </div>
                                    <mat-divider></mat-divider>

                                    <p class="template-panel-hint">Choose a template to apply its layout to this report.</p>

                                    <pv-filter-search
                                        [options]="state.templateOptions"
                                        [formControl]="templateControl"
                                        dataLabel="Templates"
                                        searchLabel="label"
                                    >
                                    </pv-filter-search>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <div class="sidebar-heading">Report Options</div>
                                <mat-divider></mat-divider>

                                <div class="sidebar-subheading">Report</div>
                                <pv-report-settings
                                    [model]="state.report">
                                </pv-report-settings>

                                <!-- Per-page typography and orientation overrides. Changing a page's
                                     orientation resizes just that page's grid; EditPageOptions clamps
                                     any component that no longer fits instead of orphaning it. -->
                                <ng-container *ngIf="pageState$ | async as pageState">
                                    <ng-container *ngFor="let key of state.pageKeys">
                                        <ng-container *ngIf="pageState.entities[key] as pageData">
                                            <mat-divider class="settings-divider"></mat-divider>
                                            <div class="sidebar-subheading">Page {{ pageData.page?.index + 1 }}</div>

                                            <pv-page-settings
                                                [model]="pageData"
                                                [showOrientation]="true">
                                            </pv-page-settings>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                        <!-- SWITCH DRAWER CONTEXT -->
                    </ng-container>
                </ng-container>


            </ng-container>
        </mat-drawer>
        <!-- RIGHT SIDEBAR -->

    </mat-drawer-container>
</pv-view>